import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { apply } from "../actions/volunteerApplicationActions";
import {
  VOLUNTEER_APPLY_FAIL,
  VOLUNTEER_APPLY_RESET,
} from "../constants/volunteerApplicationConstants";

import {
  bullets,
  contactMethods,
  interests,
  requiredFieldsErrorMessage,
  skills,
  volunteerApplicationFailureMessage,
  volunteerApplicationSuccessMessage,
} from "../constants/helpers";

import Logo from "../assets/logos/logo-peh-yellow.png";
import PhoneInput from "react-phone-input-2";
import AppAlert from "../components/AppAlert";
import Loader from "../components/Loader";

const VolunteerApplicationScreen = () => {
  const volunteerApply = useSelector((state) => state.volunteerApply);
  const { loading, error: failed, success: applied } = volunteerApply;

  const dispatch = useDispatch();

  // skills
  const [skillsArray, setSkillsArray] = useState(
    new Array(skills.length).fill(false),
  );

  const [selectedSkills, setSelectedSkills] = useState([]);

  const skillsHandler = (position) => {
    const updatedCheckedSkills = skillsArray.map((itemSkills, index) =>
      index === position ? !itemSkills : itemSkills,
    );

    setSkillsArray(updatedCheckedSkills);
  };

  useEffect(() => {
    if (skillsArray?.length) {
      setSelectedSkills(
        skills
          .map((ele) => ele.title)
          .filter((ele, index) => skillsArray[index]),
      );
    }
  }, [skillsArray]);

  // interests
  const [interestsArray, setInterestsArray] = useState(
    new Array(interests.length).fill(false),
  );

  const [selectedInterests, setSelectedInterests] = useState([]);

  const interestsHandler = (position) => {
    const updatedCheckedInterests = interestsArray.map((itemInterests, index) =>
      index === position ? !itemInterests : itemInterests,
    );

    setInterestsArray(updatedCheckedInterests);
  };

  useEffect(() => {
    if (interestsArray?.length) {
      setSelectedInterests(
        interests.filter((ele, index) => interestsArray[index]),
      );
    }
  }, [interestsArray]);

  // contact method
  const [contactMethodArray, setContactMethodArray] = useState(
    new Array(contactMethods.length).fill(false),
  );

  const [selectedMethods, setSelectedMethods] = useState([]);

  const methodsHandler = (position) => {
    const updatedCheckedMthods = contactMethodArray.map((itemMethods, index) =>
      index === position ? !itemMethods : itemMethods,
    );

    setContactMethodArray(updatedCheckedMthods);
  };

  useEffect(() => {
    if (contactMethodArray?.length) {
      setSelectedMethods(
        contactMethods.filter((ele, index) => contactMethodArray[index]),
      );
    }
  }, [contactMethodArray]);

  //
  const [otherSkills, setOtherSkills] = useState("");

  const otherSkillsHandler = (e) => {
    setOtherSkills(e.target.value);
  };

  const [otherInterests, setOtherInterests] = useState("");

  const otherInterestsHandler = (e) => {
    setOtherInterests(e.target.value);
  };

  const [name, setName] = useState("");

  const nameHandler = (e) => {
    setName(e.target.value);
  };

  const [dob, setDob] = useState("2000-01-01");

  const dobHandler = (e) => {
    setDob(e.target.value);
  };

  const [phone, setPhone] = useState("");

  const phoneHandler = (e) => {
    setPhone(e);
  };

  const [email, setEmail] = useState("");

  const emailHandler = (e) => {
    setEmail(e.target.value);
  };

  const [address, setAddress] = useState("");

  const addressHandler = (e) => {
    setAddress(e.target.value);
  };

  // submit
  const submitHandler = (e) => {
    e.preventDefault();

    if (
      selectedSkills.length &&
      name.length &&
      dob.length &&
      phone.length &&
      email.length &&
      address.length &&
      selectedMethods.length
    ) {
      const application = {
        selectedSkills,
        otherSkills,
        selectedInterests,
        otherInterests,
        name,
        dob,
        phone,
        email,
        address,
        selectedMethods,
      };

      dispatch(apply(application));
    } else {
      dispatch({
        type: VOLUNTEER_APPLY_FAIL,
        payload: requiredFieldsErrorMessage,
      });
    }
  };

  //

  const [showGoTopButton, setShowGoTopButton] = useState(false);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    document.addEventListener("scroll", () => {
      setShowGoTopButton(document.documentElement.scrollTop > 460);
    });
  }, []);

  useEffect(() => {
    if (failed || applied) {
      if (applied) {
        setSkillsArray(new Array(skills.length).fill(false));
        setSelectedSkills([]);
        setInterestsArray(new Array(interests.length).fill(false));
        setSelectedInterests([]);
        setContactMethodArray(new Array(contactMethods.length).fill(false));
        setSelectedMethods([]);
        setOtherSkills("");
        setOtherInterests("");
        setName("");
        setDob("");
        setPhone("");
        setEmail("");
        setAddress("");
      }

      setTimeout(() => {
        dispatch({ type: VOLUNTEER_APPLY_RESET });
      }, 7000);
    }

    // eslint-disable-next-line
  }, [failed, applied, dispatch]);

  return (
    <main className="offwhite-bg relative">
      {loading && <Loader />}
      {applied && (
        <AppAlert type="success" message={volunteerApplicationSuccessMessage} />
      )}
      {failed && (
        <AppAlert type="error" message={volunteerApplicationFailureMessage} />
      )}
      <div className="bg-primary">
        <div className="container">
          <div className="pt-3 lg:pt-6 pb-8 lg:pb-0">
            <Link
              to="/"
              className="fixed top-6 z-50 text-primary mb-3 bg-white hover:bg-secondary px-3 h-[43px] shadow-lg grid place-items-center with-transition"
            >
              <i
                className="iconify text-lg"
                data-icon="ep:arrow-up-bold"
                data-rotate="270deg"
              />
            </Link>
            <img
              src={Logo}
              alt="Logo"
              className="ml-auto pt-3 w-56 h-2/3 block lg:hidden"
            />
          </div>
          <img
            src={Logo}
            alt="Logo"
            className="w-2/3 md:w-56 mx-auto mt-2 hidden lg:block"
          />
          <p
            data-aos="zoom-in"
            data-aos-duration="1000"
            className="my-4 h-0.5 w-full bg-secondary md:w-2/5 mx-auto"
          />
          <h1 className="leading-none text-center pb-6 font-title offwhite-text uppercase">
            Volunteer Application
          </h1>
        </div>
      </div>

      <div className="bg-salmon text-primary grid md:grid-cols-2 gap-12 md:items-center">
        <div className="hidden md:block" />
        <div
          className="h-[260px] md:h-[484px] bg-cover bg-no-repeat bg-center"
          style={{
            backgroundImage: `url(${require("../assets/img/volunteer-application/woman-taking-care-of-plants.jpg")})`,
          }}
        />
        <div className="md:absolute w-full">
          <div className="container grid grid-cols-2">
            <div className="col-span-2 md:col-span-1 pb-12 lg:pb-0">
              <h2 className="mb-5">Requirements for all volunteers:</h2>

              <ul className="text-start flex flex-col gap-5 list-disc pl-4">
                <li>
                  <p>
                    <strong>
                      An interest in history and a willingness to learn
                    </strong>
                    , whether about human history or historical gardening
                    techniques.
                  </p>
                </li>
                <li>
                  <p>
                    <strong>Excellent communication skills:</strong> effectively
                    and clearly communicating with visitors, staff, and other
                    volunteers is essential. This includes asking for help and
                    clarification, and being able to answer questions from
                    others.
                  </p>
                </li>
                <li>
                  <p>
                    <strong>Reliability:</strong> committing to assigned shifts
                    is important for the smooth operation of the museum and
                    gardens.
                  </p>
                </li>
                <li>
                  <p>
                    <strong>Attention to details:</strong> taking care to ensure
                    accuracy in the task assigned, whether it’s in planting and
                    pruning, answering visitor questions, or recording artefact
                    data; we want to ensure that we’re doing our very best in
                    looking after Point Ellice House.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <button
        onClick={scrollTop}
        className={`with-transition duration-300 text-primary bg-white hover:bg-secondary px-3 h-[43px] shadow-lg fixed bottom-4 right-4 md:bottom-10 md:right-10 text-4xl z-20
         ${showGoTopButton ? "opacity-100" : "opacity-0 pointer-events-none"} `}
      >
        <i className="iconify text-lg" data-icon="ep:arrow-up-bold" />
      </button>
      <form onSubmit={submitHandler}>
        <section className="text-primary pt-12 lg:pt-28 container">
          <div className="mb-12 text-center">
            <h2 className="text-4xl uppercase">Role Description</h2>
            <div
              data-aos="zoom-in"
              data-aos-duration="1000"
              className="my-2 h-0.5 w-full bg-secondary md:w-2/5 mx-auto"
            />
            <span>* (Please select at least one role) *</span>
          </div>

          <section className="text-primary container mb-6 lg:mb-10 mt-14">
            <p className="text-primary">
              Fields marked with ( <span className="text-secondary">*</span> )
              are required
            </p>
          </section>

          {skills.map((skill, index) => (
            <article key={index} className="py-12 px-3 md:px-24 bg-white mb-5">
              <div className="mb-7 md:w-fit">
                <div className="flex gap-4 items-center">
                  <input
                    type="checkbox"
                    className="cursor-pointer accent-secondary"
                    name={skill.title}
                    id={skill.title}
                    checked={skillsArray[index]}
                    onChange={() => skillsHandler(index)}
                  />
                  <label
                    htmlFor={skill.title}
                    className="text-4xl uppercase cursor-pointer hover:text-secondary with-transition"
                  >
                    {skill.title}
                  </label>
                </div>
                <div
                  data-aos="zoom-in"
                  data-aos-duration="1000"
                  className="my-2 h-0.5 w-full bg-secondary"
                />
              </div>
              <ul className="space-y-5 pl-6">
                {skill.items.map((ele, index) => (
                  <li key={index} className="flex items-start gap-4">
                    <span>◼</span>
                    <p>
                      {bullets[index] && <strong>{bullets[index]}:</strong>}{" "}
                      {ele}
                    </p>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </section>

        <section className="text-primary container mb-12 lg:mb-28 lg:w-10/12 mt-14">
          <label className="col-span-2">
            <p>
              Do you have any other skills or experiences you’d like us to know
              about? Tell us here:
            </p>
            <textarea
              name="suggestions"
              className="outline-secondary h-32 md:h-40 bg-white border-[1px] border-primary w-full mt-2 p-2"
              value={otherSkills}
              onChange={otherSkillsHandler}
            />
          </label>
          <p className="mt-12 mb-7 font-bold">
            In addition to the roles described above, please indicate if you
            have any interest in additional volunteer activities:
          </p>
          <div className="flex flex-wrap gap-5 lg:gap-20 mb-12">
            {interests.map((ele, index) => (
              <div key={index} className="flex gap-4 items-center">
                <input
                  type="checkbox"
                  name={ele}
                  id={ele}
                  className="cursor-pointer accent-secondary"
                  checked={interestsArray[index]}
                  onChange={() => interestsHandler(index)}
                />
                <p>
                  <label
                    htmlFor={ele}
                    className="cursor-pointer hover:text-secondary with-transition"
                  >
                    {ele}
                  </label>
                </p>
              </div>
            ))}
          </div>
          <label>
            <p>Other interests (feel free to suggest your interests):</p>
            <textarea
              name="suggestions"
              className="outline-secondary h-32 md:h-40 bg-white border-[1px] border-primary w-full mt-2 p-2"
              value={otherInterests}
              onChange={otherInterestsHandler}
            />
          </label>
        </section>

        <section className="container text-primary">
          <div className="grid grid-cols-2 gap-5 lg:w-[86%] lg:mx-auto">
            <label className="col-span-2 md:col-span-1">
              <span>Name *</span>
              <input
                required
                type="text"
                name="name"
                className="outline-secondary h-10 bg-white border-[1px] border-primary w-full mt-2 p-2"
                value={name}
                onChange={nameHandler}
              />
            </label>
            <label className="col-span-2 md:col-span-1">
              <span>Date of Birth *</span>
              <div className="overflow-hidden relative w-full mt-2 border-[1px] border-primary">
                <input
                  type="date"
                  required
                  id="birthday"
                  name="birthday"
                  className="outline-secondary h-10 bg-white w-[120%] p-2 pr-3"
                  value={dob}
                  onChange={dobHandler}
                />
                <i
                  className="iconify absolute right-4 top-1/2 -translate-y-1/2 text-xl"
                  data-icon="majesticons:calendar"
                />
              </div>
            </label>
            <label className="col-span-2 md:col-span-1">
              <span className="block mb-2">Phone *</span>
              <PhoneInput
                required
                className="w-full outline-secondary bg-white"
                country={"ca"}
                countryCodeEditable={false}
                value={phone}
                onChange={(phone) => phoneHandler?.(phone)}
              />
            </label>
            <label className="col-span-2 md:col-span-1">
              <span>Email Address *</span>
              <input
                required
                type="email"
                name="email"
                className="outline-secondary h-10 bg-white border-[1px] border-primary w-full mt-2 p-2"
                value={email}
                onChange={emailHandler}
              />
            </label>
            <label className="col-span-2">
              <span>Address *</span>
              <input
                required
                type="text"
                name="addressLine1"
                className="outline-secondary h-10 bg-white border-[1px] border-primary w-full mt-2 p-2"
                value={address}
                onChange={addressHandler}
              />
            </label>
            <div className="col-span-2 flex flex-wrap gap-10 mb-7 md:my-10">
              <p className="text-lg">How would you prefer to be contacted? *</p>
              {contactMethods.map((ele, index) => (
                <div key={index} className="flex gap-4 items-center">
                  <input
                    type="checkbox"
                    name={ele}
                    id={ele}
                    className="cursor-pointer accent-secondary"
                    checked={contactMethodArray[index]}
                    onChange={() => methodsHandler(index)}
                  />
                  <p>
                    <label
                      htmlFor={ele}
                      className="cursor-pointer hover:text-secondary with-transition"
                    >
                      {ele}
                    </label>
                  </p>
                </div>
              ))}
            </div>
            <div className="mt-7 col-span-2">
              <input
                type="submit"
                value="Submit"
                className="col-span-2 lg:mt-2 with-transition bg-secondary hover:bg-primary  uppercase font-bold w-full md:w-48 py-3 text-primary hover:text-secondary mx-auto md:ml-0 cursor-pointer"
              />
            </div>
          </div>
        </section>
      </form>
      <div className="container mt-20 md:mt-28 pb-5">
        <span className="block w-full border-t-[1px] border-primary mb-2 mx-auto" />
        <p className="lg:flex lg:justify-between px-3 lg:px-0 text-xs text-center text-primary">
          Copyright © 2023, Forager Foundation
          <span className="block">
            website created by
            <span className="font-semibold tracking-wide">
              {" "}
              forager | <span className="text-orange-digital">digital</span>
            </span>
          </span>
        </p>
      </div>
    </main>
  );
};

export default VolunteerApplicationScreen;
